module.exports = __webpack_public_path__ + "img/home-swap-icon.0d73d3f6.svg";